import * as React from 'react'
import { Grid, Paper } from '@mui/material'
import { formatDate } from 'date-fns'
import GridItem from 'src/components/grid-item/GridItem'
import { BusinessReport } from 'src/modules/motor-credito/serasa/serasa.experian.business.types'
import AcaoJudicial from './AcaoJudicial'
import Consultas from './Consultas'
import Contatos from './Contatos'
import ControleAdministracao from './ControleAdministracao'
import ControleParticipacoes from './ControleParticipacoes'
import ControleSocietario from './ControleSocietario'
import Endereco from './Endereco'
import Identificacao from './Identificacao'
import Pefin from './Pefin'
import Refin from './Refin'

export type DadosEmpresaProps = {
    businness: BusinessReport
}

export default function ExperianDadosEmpresa({ businness }: DadosEmpresaProps) {
    if (!businness.reports || businness.reports.length === 0) {
        return (
            <Paper elevation={3} style={{ padding: 10 }}>
                Nenhum dado encontrado
            </Paper>
        )
    }

    return (
        <>
            {businness.reports.map((empresa) => (
                <Paper key={empresa.identificationReport.documentNumber} elevation={3} style={{ padding: 10 }}>
                    <Grid
                        container
                        spacing={1}
                        sx={{
                            paddingTop: 2,
                            paddingBottom: 2,
                            paddingLeft: 5,
                            paddingRight: 5
                        }}
                    >
                        <GridItem label="Tipo Relatório" value={empresa.reportName} xs={12} />
                        <GridItem
                            label="Data da Atualização"
                            value={
                                empresa.identificationReport.updateDate
                                    ? formatDate(empresa.identificationReport.updateDate, 'dd/MM/yyyy')
                                    : '-'
                            }
                            xs={12}
                        />
                        <GridItem label="CNPJ" value={empresa.identificationReport.documentNumber || '-'} xs={12} />
                    </Grid>
                    <Identificacao empresa={empresa} />
                    <Endereco empresa={empresa} />
                    <Contatos empresa={empresa} />

                    <ControleSocietario controleSocietario={businness.optionalFeatures?.QSAReport} />
                    <ControleAdministracao controleAdministracao={businness.optionalFeatures?.QSAReport} />
                    <ControleParticipacoes controleParticipacoes={businness.optionalFeatures?.QSAReport} />
                    <Consultas consultas={empresa.facts.inquiryCompanyResponse?.quantity?.historical} />
                    <Pefin pefin={empresa.negativeData.pefin} />
                    <Refin refin={empresa.negativeData.refin} />
                    <AcaoJudicial acaoJudicial={empresa.facts.judgementFilings} />
                </Paper>
            ))}
        </>
    )
}
